import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page center" }
const _hoisted_2 = { class: "w-50" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "is-size-3" }
const _hoisted_5 = { class: "button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", { src: _ctx.forbidden }, null, 8 /* PROPS */, _hoisted_3)
    ]),
    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('dashboard.not_authorized')), 1 /* TEXT */),
    _createVNode(_component_router_link, { to: "/dashboard" }, {
      default: _withCtx(() => [
        _createElementVNode("button", _hoisted_5, _toDisplayString(_ctx.$t('dashboard.back_to_dashboard')), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}